import { Gap } from '@/components/gap';
import { EUGENE_WALLET_ADDRESS } from '@/constants/shared';
import { useBadges } from '@/hooks/useBadges';
import { useSocialConnections } from '@/hooks/useSocialConnections';
import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { AssetsTable } from './AssetsTable';
import { PlumePointsSection } from './PlumePointsSection';
import { ProfileBackButton, ProfileHeader } from './ProfileHeader';
import { useProfileWalletAddress } from './useProfileWalletAddress';

export const Profile = () => {
  const { profileAddress } = useProfileWalletAddress();
  const [showAllAssets, setShowAllAssets] = useState(false);
  // const { stats, isLoading } = useWalletAddressUserData(profileAddress);
  // prefetch data by calling query early
  useBadges(profileAddress);
  useSocialConnections(profileAddress);
  // if (isLoading) return <Spinner />;
  // if (!stats)
  //   return <Text>Zoinks! No user was found for address {profileAddress}, you should tell them to sign up!</Text>;

  if (profileAddress?.toLowerCase() === EUGENE_WALLET_ADDRESS.toLowerCase()) {
    return (
      <Box>
        <ProfileBackButton />
        <VStack rounded="3xl" bg="#000000/80" p={6} color="white" gap={8} minH="unset" w="full" mb="auto" pb={8}>
          <VStack gap={4}>
            <Image src="/assets/profile/eugene.png" boxSize={100} rounded="md" />
            <Text fontFamily="Lufga, sans-serif" fontWeight="500" fontSize="3xl">
              Eugene Y. Q. Shen
            </Text>
            <Box fontFamily="Lufga, sans-serif" fontWeight="500" fontSize="xl">
              #1 <span style={{ color: '#AAAAAA' }}>Global Rank</span>
            </Box>
          </VStack>
          <Text
            fontFamily="IBMPlexMono, sans-serif"
            fontWeight="500"
            fontSize="lg"
            maxW={['280px', '680px']}
            textAlign="center"
          >
            In memory of Eugene Shen, a brilliant engineer and colleague whose vision and dedication helped bring Plume
            to life.
          </Text>
          <Box bg="#AAAAAA" rounded="md" h="7px" w="52px"></Box>
          <Text fontFamily="IBMPlexMono, sans-serif" fontWeight="500" fontSize="lg">
            Your work lives on.
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box>
      <ProfileHeader />
      <Gap />
      <AssetsTable showAllAssets={showAllAssets} setShowAllAssets={setShowAllAssets} />
      <Gap />
      <PlumePointsSection />
    </Box>
  );
};
